import { render, staticRenderFns } from "./SendEgiftPanelRecipientsCopyPaste.vue?vue&type=template&id=7beef11c&scoped=true"
import script from "./SendEgiftPanelRecipientsCopyPaste.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelRecipientsCopyPaste.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelRecipientsCopyPaste.vue?vue&type=style&index=0&id=7beef11c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beef11c",
  null
  
)

export default component.exports